import React, { useCallback } from 'react';
import { animated, useTransition } from 'react-spring';
import { useDispatch, useSelector } from 'react-redux';
import { AdminModalBackdrop } from '../admin-modal-backdrop';
import { AdminModalControllerProps } from './admin-modal-controller-props';
import { AdminModalName } from '../../../state';
import { getCurrentAdminModal } from '../../../selectors';
import { getModal } from './get-modal';
import { popAdminModal } from '../../../actions';
import styled from 'styled-components';

const AnimatedDiv = styled.div`
  flex: 1;
  pointer-events: auto;
  position: absolute;
  z-index: 5001;
`;

const Container = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  pointer-events: none;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 5000;
`;

const Animation = animated(AnimatedDiv);

export const AdminModalController: React.FunctionComponent<
  AdminModalControllerProps
> = (): React.ReactElement => {
  const dispatch = useDispatch();
  const currentEntry = useSelector(getCurrentAdminModal);

  const modalTransitions = useTransition(
    currentEntry,
    (entry): AdminModalName | 'default' => (entry ? entry.name : 'default'),
    {
      config: { friction: 50, tension: 400 },
      // initial: { opacity: 0, transform: 'translate3d(0, 20%, 0)' },
      enter: { opacity: 1, transform: 'translate3d(0, 0, 0)' },
      from: { opacity: 0, transform: 'translate3d(0, 10%, 0)' },
      leave: { opacity: 0, transform: 'translate3d(0, 10%, 0)' },
    },
  );

  const onBackdropClick = useCallback(() => {
    dispatch(popAdminModal());
  }, []);

  return (
    <Container>
      {modalTransitions.map(
        ({ item, props, key }) =>
          item && (
            <Animation style={props} key={key}>
              {getModal(item)}
            </Animation>
          ),
      )}
      <AdminModalBackdrop visible={!!currentEntry} onClick={onBackdropClick} />
    </Container>
  );
};

AdminModalController.displayName = 'AdminModalController';
